const layout1 = `
    <div class="bg-[#F5F5F4] py-5 md:py-16">
                <div class="container mx-auto px-[15px] max-w-[1240px]">
                    <div class="space-y-5 md:space-y-[64px]">
                        <div class="flex flex-col lg:flex-row justify-between gap-3 md:gap-6">
                            <div class="xs:w-full lg:w-1/2 space-y-1 md:space-y-5">
                                <h2 class="text-2xl md:text-4xl text-[#292524] font-medium">
                                    Why book with us?
                                </h2>
                                <p class="text-sm md:text-base text-[#292524] font-normal">
                                    Dolor augue curae montes eget sollicitudin
                                    diam praesent non mus in lobortis. Ligula
                                    magna himenaeos dictumst cubilia dolor morbi
                                    letius tempor in convallis.
                                </p>
                                <div class="grid xs:grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-2 gap-3 md:gap-6 pt-2 md:pt-0">
                                    <div class="bg-white flex gap-4 md:gap-5 p-4 rounded-[10px] shadow-sm">
                                        <div class="min-w-8 mt-2">
                                            <img
                                                src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/best-price.svg"
                                                width="100%"
                                                height="auto"
                                                alt="img"
                                            />
                                        </div>
                                        <div>
                                            <h4 class="text-base text-stone-800 font-semibold leading-[24px]">
                                                Best Prices
                                            </h4>
                                            <p class="text-sm text-stone-800 font-normal leading-[20px]">
                                                Enjoy discounts at participating
                                                properties worldwide
                                            </p>
                                        </div>
                                    </div>
                                    <div class="bg-white flex gap-4 md:gap-5 p-4 rounded-[10px] shadow-sm">
                                        <div class="min-w-8 mt-2">
                                            <img
                                                src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/secured-payment.svg"
                                                width="85%"
                                                height="auto"
                                                alt="img"
                                            />
                                        </div>
                                        <div>
                                            <h4 class="text-base text-stone-800 font-semibold leading-[24px]">
                                                Secured Payment
                                            </h4>
                                            <p class="text-sm text-stone-800 font-normal leading-[20px]">
                                                Enjoy discounts at participating
                                                properties worldwide
                                            </p>
                                        </div>
                                    </div>
                                    <div class="bg-white flex gap-4 md:gap-5 p-4 rounded-[10px] shadow-sm">
                                        <div class="min-w-8">
                                            <img
                                                src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/refund-white.svg"
                                                width="100%"
                                                height="auto"
                                                alt="img"
                                            />
                                        </div>
                                        <div>
                                            <h4 class="text-base text-stone-800 font-semibold leading-[24px]">
                                                Easy Returns
                                            </h4>
                                            <p class="text-sm text-stone-800 font-normal leading-[20px]">
                                                Enjoy discounts at participating
                                                properties worldwide
                                            </p>
                                        </div>
                                    </div>
                                    <div class="bg-white flex gap-4 md:gap-5 p-4 rounded-[10px] shadow-sm">
                                        <div class="min-w-8">
                                            <img
                                                src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/24-hours.svg"
                                                width="100%"
                                                height="auto"
                                                alt="img"
                                            />
                                        </div>
                                        <div>
                                            <h4 class="text-base text-stone-800 font-semibold leading-[24px]">
                                                24/7 Support
                                            </h4>
                                            <p class="text-sm text-stone-800 font-normal leading-[20px]">
                                                Enjoy discounts at participating
                                                properties worldwide
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="xs:w-full xs:mx-auto lg:mx-0 lg:w-1/2">
                                <img
                                    src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-21.png"
                                    width="100%"
                                    height="auto"
                                    alt="img"
                                />
                            </div>
                        </div>

                        <div class="!mb-5 md:!mb-[64px]">
                            <h3 class="text-2xl md:text-[36px] text-center text-stone-800 font-medium leading-[40px] mb-3 md:mb-5">
                                Easy steps to buy a ticket
                            </h3>
                            <div class="grid xs:grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6">
                                <div class="bg-white w-full h-[244px] px-4 py-8 rounded-[10px] md:rounded-xl shadow-sm">
                                    <h4 class="w-[64px] h-[64px] bg-red-600 text-white text-4xl font-medium leading-[40px] flex justify-center items-center mx-auto rounded-xl mb-3">
                                        1
                                    </h4>
                                    <h6 class="text-red-600 text-center text-xl font-semibold leading-[28px] mb-1 line-clamp-1">
                                        Search Destination!
                                    </h6>
                                    <p class="text-stone-800 text-base text-center font-semibold leading-[24px] line-clamp-3">
                                        Go to bdtickets Website, Select your
                                        location, Select Bus Type, Select the
                                        date of your journey
                                    </p>
                                </div>
                                <div class="bg-white w-full h-[244px] px-4 py-8 rounded-[10px] md:rounded-xl shadow-sm">
                                    <h4 class="w-[64px] h-[64px] bg-red-600 text-white text-4xl font-medium leading-[40px] flex justify-center items-center mx-auto rounded-xl mb-3">
                                        2
                                    </h4>
                                    <h6 class="text-red-600 text-center text-xl font-semibold leading-[28px] mb-1 line-clamp-1">
                                        Search Destination!
                                    </h6>
                                    <p class="text-stone-800 text-base text-center font-semibold leading-[24px] line-clamp-3">
                                        Click the View Seats option, Select your
                                        seats, Provide all the information,
                                        Select the Next option
                                    </p>
                                </div>
                                <div class="bg-white w-full h-[244px] px-4 py-8 rounded-[10px] md:rounded-xl shadow-sm">
                                    <h4 class="w-[64px] h-[64px] bg-red-600 text-white text-4xl font-medium leading-[40px] flex justify-center items-center mx-auto rounded-xl mb-3">
                                        3
                                    </h4>
                                    <h6 class="text-red-600 text-center text-xl font-semibold leading-[28px] mb-1 line-clamp-1">
                                        Search Destination!
                                    </h6>
                                    <p class="text-stone-800 text-base text-center font-semibold leading-[24px] line-clamp-3">
                                        You can pay via VISA, AMEX, Master Card,
                                        Nagad and bKash and more, After making
                                        all the payment procedures, you will get
                                        your ticket.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bg-red-600 mb-5 md:mb-[64px] py-5 md:py-[68px]">
                    <div class="container mx-auto px-[15px] max-w-[1240px]">
                        <div class="flex flex-col lg:flex-row xs:items-center lg:items-center justify-between sm:px-8 lg:px-0">
                            <p class="text-2xl md:text-[36px] text-white xs:text-center lg:text-left font-medium leading-[32px] md:leading-[40px] xs:mb-6 lg:mb-0">
                                We are the most affordable{" "}
                                <br class="hidden md:inline-block" /> and
                                comfortable bus in the{" "}
                                <br class="hidden md:inline-block" /> country.
                            </p>
                            <div class="grid grid-cols-2 gap-6 max-md:mt-3">
                                <div class="xs:w-full sm:w-[260px] bg-white flex flex-col justify-center items-center gap-1 p-4 rounded-[10px] md:rounded-xl">
                                    <span class="text-[36px] text-red-600 font-medium leading-[40px]">
                                        34
                                    </span>
                                    <span class="text-base text-[#292524] font-semibold leading-[24px]">
                                        Buses
                                    </span>
                                </div>
                                <div class="xs:w-full sm:w-[260px] bg-white flex flex-col justify-center items-center gap-1 p-4 rounded-[10px] md:rounded-xl">
                                    <span class="text-[36px] text-red-600 font-medium leading-[40px]">
                                        12
                                    </span>
                                    <span class="text-base text-[#292524] font-semibold leading-[24px]">
                                        Districts Covered
                                    </span>
                                </div>
                                <div class="xs:w-full sm:w-[260px] bg-white flex flex-col justify-center items-center gap-1 p-4 rounded-[10px] md:rounded-xl">
                                    <span class="text-[36px] text-red-600 font-medium leading-[40px]">
                                        60+
                                    </span>
                                    <span class="text-base text-[#292524] font-semibold leading-[24px]">
                                        Daily trips
                                    </span>
                                </div>
                                <div class="xs:w-full sm:w-[260px] bg-white flex flex-col justify-center items-center gap-1 p-4 rounded-[10px] md:rounded-xl">
                                    <span class="text-[36px] text-red-600 font-medium leading-[40px]">
                                        1000+
                                    </span>
                                    <span class="text-base text-[#292524] font-semibold leading-[24px]">
                                        Tickets per day
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container mx-auto px-[15px] max-w-[1240px]">
                    <div class="space-y-5 md:space-y-[64px]">
                        <div>
                            <h2 class="text-2xl md:text-4xl text-center text-[#292524] font-medium mb-4">
                                Our Seats
                            </h2>
                            <div class="grid xs:grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6">
                                <div>
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-22.png"
                                        width="100%"
                                        height="auto"
                                        alt="img"
                                    />

                                    <div class="px-4 pt-3 pb-4">
                                        <h4 class="text-xl text-center text-stone-800 font-medium leading-[28px]">
                                            Business Class
                                        </h4>
                                    </div>
                                </div>
                                <div>
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-23.png"
                                        width="100%"
                                        height="auto"
                                        alt="img"
                                    />

                                    <div class="px-4 pt-3 pb-4">
                                        <h4 class="text-xl text-center text-stone-800 font-medium leading-[28px]">
                                            Economy Class
                                        </h4>
                                    </div>
                                </div>
                                <div>
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-24.png"
                                        width="100%"
                                        height="auto"
                                        alt="img"
                                    />

                                    <div class="px-4 pt-3 pb-4">
                                        <h4 class="text-xl text-center text-stone-800 font-medium leading-[28px]">
                                            Non-AC Seats
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="!mb-5 md:!mb-[64px]">
                            <h3 class="text-[24px] md:text-[36px] text-center text-stone-800 font-medium leading-[32px] md:leading-[40px] mb-3 md:mb-5">
                                Available bus types
                            </h3>
                            <div class="grid xs:grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-6">
                                <div class="bg-red-600  w-full p-4 rounded-xl">
                                    <div class="w-[64px] h-[64px] bg-[#F5F5F4] flex justify-center items-center mx-auto rounded-xl mb-3">
                                        <img
                                            src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/icon_ac_XL_light.svg"
                                            width="40"
                                            height="auto"
                                            alt="img"
                                        />
                                    </div>
                                    <h6 class="text-white text-center text-base md:text-xl font-semibold leading-[24px] mb-1 line-clamp-1">
                                        AC
                                    </h6>
                                    <p class="text-white text-xs md:text-sm text-center font-normal leading-[20px] line-clamp-2">
                                        The most beautiful AC buses
                                    </p>
                                </div>
                                <div class="bg-red-600 w-full p-4 rounded-xl">
                                    <div class="w-[64px] h-[64px] bg-[#F5F5F4] flex justify-center items-center mx-auto rounded-xl mb-3">
                                        <img
                                            src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/icon_non_ac_L_light.svg"
                                            width="40"
                                            height="auto"
                                            alt="img"
                                        />
                                    </div>
                                    <h6 class="text-white text-center text-base md:text-xl font-semibold leading-[24px] mb-1 line-clamp-1">
                                        Non-AC
                                    </h6>
                                    <p class="text-white text-xs md:text-sm text-center font-normal leading-[20px] line-clamp-2">
                                        The most beautiful AC buses
                                    </p>
                                </div>
                                <div class="bg-red-600 w-full p-4 rounded-xl">
                                    <div class="w-[64px] h-[64px] bg-[#F5F5F4] flex justify-center items-center mx-auto rounded-xl mb-3">
                                        <img
                                            src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-seat-side-view-outline-svgrepo-com 1.svg"
                                            width="40"
                                            height="auto"
                                            alt="img"
                                        />
                                    </div>
                                    <h6 class="text-white text-center text-base md:text-xl font-semibold leading-[24px] mb-1 line-clamp-1">
                                        Sleepers
                                    </h6>
                                    <p class="text-white text-xs md:text-sm text-center font-normal leading-[20px] line-clamp-2">
                                        The most beautiful AC buses
                                    </p>
                                </div>
                                <div class="bg-red-600 w-full p-4 rounded-xl">
                                    <div class="w-[64px] h-[64px] bg-[#F5F5F4] flex justify-center items-center mx-auto rounded-xl mb-3">
                                        <img
                                            src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-svgrepo-com 1.svg"
                                            width="40"
                                            height="auto"
                                            alt="img"
                                        />
                                    </div>
                                    <h6 class="text-white text-center text-base md:text-xl font-semibold leading-[24px] mb-1 line-clamp-1">
                                        Double Deckers
                                    </h6>
                                    <p class="text-white text-xs md:text-sm text-center font-normal leading-[20px] line-clamp-2">
                                        The most beautiful AC buses
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
 `;

export default layout1;
